import React from 'react';

const Footer = () => {
  return (
    <footer className="app-footer">
      <span>© Warehouse Facility Management System {new Date().getFullYear()}</span>
    </footer>
  );
};

export default Footer;
